import { render, staticRenderFns } from "./Postcard.vue?vue&type=template&id=fb5d39e2&scoped=true&"
import script from "./Postcard.vue?vue&type=script&lang=js&"
export * from "./Postcard.vue?vue&type=script&lang=js&"
import style0 from "./Postcard.vue?vue&type=style&index=0&id=fb5d39e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5d39e2",
  null
  
)

component.options.__file = "Postcard.vue"
export default component.exports